var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c1"},_vm._l((_vm.mapList),function(item){return _c('div',{key:item.name,staticClass:"c1-item"},[_c('img',{attrs:{"src":item.img,"alt":""}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(item.name))]),_c('div',{staticClass:"val"},[_vm._v(_vm._s(item.val))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }